import React, { FC } from 'react'
import { EuiFlexGroup, EuiFlexItem, EuiTitle, EuiSpacer } from '@elastic/eui'
import BackgroundContentCard from '../BackgroundContentCard'
import DemographicItem from './DemographicItem'

interface DemographicsSectionProps {
    demographics: Record<string, string>
    width?: string
}

const DemographicsSection: FC<DemographicsSectionProps> = ({ demographics, width = '350px' }) => {
    return (
        <EuiFlexItem grow={false} style={{ width, height: '100%' }}>
            <EuiFlexGroup direction="column" gutterSize="none">
                <EuiFlexItem>
                    <BackgroundContentCard>
                        <EuiTitle size="xs">
                            <h4>Demographics</h4>
                        </EuiTitle>
                        <EuiSpacer size="s" />
                        {Object.entries(demographics).map(([key, value], index) => (
                            <DemographicItem
                                key={index}
                                label={key}
                                value={value}
                                showSpacer={index < Object.entries(demographics).length - 1}
                            />
                        ))}
                    </BackgroundContentCard>
                </EuiFlexItem>
            </EuiFlexGroup>
        </EuiFlexItem>
    )
}

export default DemographicsSection 